import { createClient } from "@supabase/supabase-js";

// Gavimas iš .env failo
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Patikriname ar aplinkos kintamieji yra teisingai nustatyti
if (!supabaseUrl || !supabaseAnonKey) {
  // Klaidos pranešimas tik programavimo režime
  if (process.env.NODE_ENV !== "production") {
    console.error("Supabase URL arba Anon Key nėra nustatyti .env faile.");
    // Galima čia įterpti mechanizmą, kuris sustabdytų programos veikimą arba rodytų pranešimą vartotojui
  }
  // Produkcinėje aplinkoje klaida tiesiog ignoruojama arba registruojama serveryje
}

// Inicializuojame Supabase klientą
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // Use PKCE flow for better security
    storageKey: 'formos-auth', // Custom storage key to avoid conflicts
    storage: {
      // Custom storage implementation to prevent token auto-consumption
      getItem: (key) => {
        if (typeof window !== 'undefined') {
          return window.localStorage.getItem(key);
        }
      },
      setItem: (key, value) => {
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(key, value);
        }
      },
      removeItem: (key) => {
        if (typeof window !== 'undefined') {
          window.localStorage.removeItem(key);
        }
      },
    },
    // Disable automatic redirect handling to prevent auto-consumption
    skipBrowserRedirect: true,
  },
  global: {
    headers: {
      "Content-Type": "application/json",
      "x-requested-with": "XMLHttpRequest", // Help identify AJAX requests
    },
  },
  realtime: {
    timeout: 30000,
  },
  // Nustatome localStorage užklausų limitus, kad išvengtume QuotaExceededError klaidos
  localStorage: {
    cacheDuration: 3600, // 1 valanda cache galiojimo
    maxAge: 3600, // Seni įrašai bus automatiškai išvalyti po 1 valandos
  },
});

// Globalus metodai darbui su duomenis
export const dataHelpers = {
  // Laukų pavadinimų konvertavimas iš snake_case į camelCase
  formatToCamelCase: (data) => {
    const fieldMap = {
      formos_pavadinimas: "formosPavadinimas",
      imones_pavadinimas: "imonesPavadinimas",
      form_object: "formObject",
      kas_pildo: "kasPildo",
      valid_to: "validTo",
      created_at: "createdAt",
      updated_at: "updatedAt",
      uzpildymo_data: "uzpildymoData",
      admin_confirmed: "adminConfirmed",
      reset_password_token: "resetPasswordToken",
      reset_token: "resetToken",
      reset_token_expires_at: "resetTokenExpiresAt",
      confirmation_token: "confirmationToken",
      confirmed_email: "confirmedEmail",
    };

    if (Array.isArray(data)) {
      return data.map((item) => dataHelpers.formatToCamelCase(item));
    }

    if (typeof data === "object" && data !== null) {
      const result = {};
      for (const key in data) {
        const newKey = fieldMap[key] || key;
        result[newKey] = data[key];
      }
      return result;
    }

    return data;
  },

  // Laukų pavadinimų konvertavimas iš camelCase į snake_case
  formatToSnakeCase: (data) => {
    const fieldMap = {
      formosPavadinimas: "formos_pavadinimas",
      imonesPavadinimas: "imones_pavadinimas",
      formObject: "form_object",
      kasPildo: "kas_pildo",
      validTo: "valid_to",
      createdAt: "created_at",
      updatedAt: "updated_at",
      uzpildymoData: "uzpildymo_data",
      adminConfirmed: "admin_confirmed",
      resetPasswordToken: "reset_password_token",
      resetToken: "reset_token",
      resetTokenExpiresAt: "reset_token_expires_at",
      confirmationToken: "confirmation_token",
      confirmedEmail: "confirmed_email",
    };

    if (typeof data === "object" && data !== null) {
      const result = {};
      for (const key in data) {
        const newKey = fieldMap[key] || key;
        result[newKey] = data[key];
      }
      return result;
    }

    return data;
  },
};

export default supabase;
